import styled from '@emotion/styled'
import {CancelOutlined, Close, Menu} from '@mui/icons-material'
import React from 'react'
import LinkButton, {} from './LinkButton'

const StyledButton = styled(LinkButton)({outline: 0})







const StyledIcon = styled('div')(({iconLarge}) => ({
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: iconLarge ? 24 : 18,
  width: iconLarge ? 24 : 18,
  svg: {
    fontSize: iconLarge ? 24 : 18
  }
}))

const IconButton = (props) => {
  const {icon, iconLarge} = props

  return (
    React.createElement(StyledButton, { ...props, type: "button",}
      , React.createElement(StyledIcon, { iconLarge: iconLarge,}
        , 
          {
            cancel: React.createElement(CancelOutlined, null ),
            close: React.createElement(Close, null ),
            menu: React.createElement(Menu, null )
          }[icon]
        
      )
    )
  )
}

export default IconButton
